import type { ReactNode } from 'react';

export const symbol_watch_button_press: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M556-324q64-64 64-156t-64-156q-64-64-156-64t-156 64q-64 64-64 156t64 156q64 64 156 64t156-64ZM332-80q-20 0-36.5-12T274-124l-25-91q-5-16-14.5-30.5T209-274q-42-37-65.5-90T120-480q0-62 23-115.5t65-90.5q16-14 26-29t15-30l25-91q5-20 21.5-32t36.5-12h136q20 0 36.5 12t21.5 32l25 91q5 16 15 30.5t26 28.5q42 36 65 89.5T680-480q0 62-23.5 115T591-274q-16 14-25.5 28.5T551-215l-25 91q-5 20-21.5 32T468-80H332Zm456.5-408.5Q780-497 780-510v-300q0-13 8.5-21.5T810-840q13 0 21.5 8.5T840-810v300q0 13-8.5 21.5T810-480q-13 0-21.5-8.5ZM331-820h138-138Zm0 680h138-138Zm-18-604q23-7 44.5-10.5T400-758q21 0 42.5 3.5T487-744l-18-76H331l-18 76Zm18 604h138l18-76q-23 6-44.5 9.5T400-203q-21 0-42.5-3.5T313-216l18 76Z"
		/>
	</svg>
);
